class NavDropdownPosition {
	dropdown?: HTMLElement[] | null;
	mobileMenu?: HTMLElement | null;
	header?: HTMLElement | null;

	constructor() {
		this.dropdown = Array.from(document.querySelectorAll('.main-nav-submenu'));
		this.header = document.querySelector('header');
		this.mobileMenu = document.querySelector('.main-nav');
		this.dropdownPosition = this.dropdownPosition.bind(this);
	}

	init() {
		window.addEventListener('load', this.dropdownPosition);
	}

	private dropdownPosition() {
		if (window.matchMedia('(min-width: 768px)').matches) {
			if (this.dropdown && this.header) {
				this.dropdown.forEach((dropdown) => {
					if (this.header) {
						dropdown.style.top = `${this.header.offsetHeight}px`;
					}
				});
			}
		} else if (this.mobileMenu && this.header) {
			this.mobileMenu.style.top = `${this.header.offsetHeight}px`;
		}
	}
}

export default new NavDropdownPosition();
